/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Editor } from 'cio/services/editor';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';

interface SwitchModalArgs {
  currentSwitchModal: SwitchModalType;
  onClose: () => void;
  switchEditor: (editor: Editor) => void;
  payloadSnippet: string;
}

export enum SwitchModalType {
  none = 'none',
  richToCustom = 'richToCustom',
  customToRich = 'customToRich',
}

export default class SwitchModal extends Component<SwitchModalArgs> {
  @service account!: AccountService;
}
